import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=5be8ba52&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=5be8ba52&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8ba52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5be8ba52')) {
      api.createRecord('5be8ba52', component.options)
    } else {
      api.reload('5be8ba52', component.options)
    }
    module.hot.accept("./Newsletter.vue?vue&type=template&id=5be8ba52&scoped=true", function () {
      api.rerender('5be8ba52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/landing/Newsletter.vue"
export default component.exports